<template>
  <div>
  <GenericPage>
    <template slot="breadcrumb-items">
      <li class="active bold">Modelo de Riesgos</li>
    </template>
    <template slot="title">
      El proceso de evaluación, selección y calificación. 
    </template>
    <template slot="body" class="text-generic">
      <ScoreContent></ScoreContent>
    </template>
  </GenericPage>
  </div>
</template>

<script>
import ScoreContent from "@components/score/ScoreContent";

import GenericPage from "./new-portal-views/GenericPage.vue";

export default {
name: "Score Page",
  components: {
    ScoreContent,
    GenericPage
}
}
</script>

<style scoped>

</style>